export default __webpack_public_path__ + "static/media/drop-shadow-topbar-day.c005e955.webp";